(function($) {
	'use strict';
	$.fn.Collection__Archive = function() {
		this.each(function() { 
			
			/*
			 * Action: Archive Collection
			 */
			var $self = $(this),
				collection_id = $self.data('cid');
			
			// Listener
			$self.off( $.Globals.clickEvent ).on( $.Globals.clickEvent, function(e) {
				e.preventDefault();
				
				// Add confirm
				var confirmed = confirm( Front.translations.confirm_archive );

				if( confirmed ) {
				
					$.Globals.ajax( 'scspaces_archive_collection', { cid: collection_id }, function( data ) {
						if( data.success ) {

							// We don't have that collections anymore.  Go to my collections
							window.location = Front.archives_url;
							
						} else {
							console.log(data);
						}
					});

				}
				
			});
		
		});
		return this;
	};
}(jQuery));